export enum DateScale {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  THREE_DAYS = '3days',
  SEVEN_DAYS = '7days',
  FOURTEEN_DAYS = '14days',
  THIRTY_DAYS = '30days',
}
